// push용 socket instance get
export function getPushSocketInstance (state) {
  return state.pushSocketInstance
}
